module.exports = __webpack_public_path__ + "img/depmap_svg_V88.66ab55c0.svg";